var $2a2d5dc14e680587$exports = {};
$2a2d5dc14e680587$exports = {
    "alpha": `Alpha`,
    "blue": `Bleu`,
    "brightness": `Luminosit\xe9`,
    "green": `Vert`,
    "hue": `Teinte`,
    "lightness": `Luminosit\xe9`,
    "red": `Rouge`,
    "saturation": `Saturation`
};


export {$2a2d5dc14e680587$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
